/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_TruncatedInputs */

const en_us2_coach_truncated = /** @type {(inputs: Coach_TruncatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This answer was cut off. A caveat may be missing: ask again before you go on.`)
};

const pt_br2_coach_truncated = /** @type {(inputs: Coach_TruncatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta resposta foi cortada. Pode faltar uma ressalva: pergunte de novo antes de seguir.`)
};

const es_419_coach_truncated = /** @type {(inputs: Coach_TruncatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta respuesta se cortó. Puede faltar una advertencia: vuelve a preguntar antes de seguir.`)
};

const pt_pt2_coach_truncated = /** @type {(inputs: Coach_TruncatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta resposta foi cortada. Pode faltar uma ressalva: pergunta de novo antes de continuares.`)
};

const fr_fr2_coach_truncated = /** @type {(inputs: Coach_TruncatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette réponse a été coupée. Une réserve manque peut-être : redemande avant de continuer.`)
};

const de_de2_coach_truncated = /** @type {(inputs: Coach_TruncatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Antwort wurde abgeschnitten. Vielleicht fehlt ein Hinweis: Frag noch mal, bevor du weitermachst.`)
};

const it_it2_coach_truncated = /** @type {(inputs: Coach_TruncatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa risposta è stata interrotta. Potrebbe mancare un'avvertenza: chiedi di nuovo prima di andare avanti.`)
};

/**
* | output |
* | --- |
* | "This answer was cut off. A caveat may be missing: ask again before you go on." |
*
* @param {Coach_TruncatedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_truncated = /** @type {((inputs?: Coach_TruncatedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_TruncatedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_truncated(inputs)
	if (locale === "es-419") return es_419_coach_truncated(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_truncated(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_truncated(inputs)
	if (locale === "de-DE") return de_de2_coach_truncated(inputs)
	if (locale === "it-IT") return it_it2_coach_truncated(inputs)
	return en_us2_coach_truncated(inputs)
});
export { coach_truncated as "coach.truncated" }